var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.706 20.99a1.692 1.692 0 0 1-1.21-.413 1.74 1.74 0 0 1 0-2.432L17.97 3.5a1.691 1.691 0 0 1 2.41.081 1.74 1.74 0 0 1 .08 2.265L5.9 20.577c-.331.287-.758.435-1.194.414Z",
    fill: "#00ff40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.164 20.99a1.695 1.695 0 0 1-1.193-.5L3.496 5.848a1.739 1.739 0 0 1 .186-2.432 1.69 1.69 0 0 1 2.218 0l14.56 14.643a1.739 1.739 0 0 1 0 2.519 1.692 1.692 0 0 1-1.296.414Z",
    fill: "#35FF61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuIcon);
export default __webpack_public_path__ + "static/media/close-menu-icon.1a62d9287c195d42ae973b1bf291375c.svg";
export { ForwardRef as ReactComponent };